import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { JSON_ONE11 } from "./JSON_DATA_Requestflowone";
import { JSON_ONE21 } from "./JSON_DATA_Responseflowone";
import { JSON_ONE31 } from "./JSON_DATA_Requestflowtwo";
import { JSON_ONE41 } from "./JSON_DATA_Responseflowtwo";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
import RequestJSONflowone from './RequestJSONflowone';
import ResponseJSONflowone from './ResponseJSONflowone';
import RequestJSONflowtwo from './RequestJSONflowtwo';
import ResponseJSONflowtwo from './ResponseJSONflowtwo';
import SettlementMISAPIDropDown from './SettlementMISAPItest/SettlementMISAPIDropDown';

function TransactionMIS() {
   const [TabCheck1, SetTabCheck1] = useState(false)
   const [TabCheck2, SetTabCheck2] = useState(false)
   const onClickCangeTab1 = () => {
      SetTabCheck1(!TabCheck1);
   }
   const onClickCangeTab2 = () => {
      SetTabCheck2(!TabCheck2);
   }
   return (
      <div class="idocs-content">
         <div class="">
            <div class="row">
               <div class="col-md-8">
                  <section id="idocs_layout1">
                     <h1>Transaction MIS</h1>
                     <hr />
                  </section>
               </div>
               <div class="col-md-4 extreme-rt-div">
               </div>
            </div>
            <div class="row">
               <div class="col-md-8 mt-60">
                  <h2 id="login-api-sec">Login API</h2>
                  <p>Transaction MIS API can be used for download transaction data without need for logging into Dashboard.
                  </p>


<div className="mt-40">
<p><b>UAT URL :</b> <span class="col-red">https://uatportal.safexpay.com/api_signUpLogin_agId/paygate</span></p>
      <p><b>Production URL : </b><span class="col-red">https://portal.safexpay.com/api_signUpLogin_agId/paygate</span></p>
</div>

                  <h6 className='mt-40'><u>AUTHORIZATIONS:</u></h6>
                  <h6 className="mt-10">HEADER PARAMETERS</h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Content-Type">
                              <span class="sc-iemWCZ fhDkLh"></span><span>Content-Type</span>
                              <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Application-JSON</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <h6>REQUEST BODY SCHEMA:  application-json</h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="userId"><span class="sc-iemWCZ fhDkLh"></span><span>userId</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Login ID.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="password"><span class="sc-iemWCZ fhDkLh"></span><span>password</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fcmKey"><span class="sc-iemWCZ fhDkLh"></span><span>fcmKey</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Used for Push Notifications</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fcmServerKey"><span class="sc-iemWCZ fhDkLh"></span><span>fcmServerKey</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Used for Push Notifications</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <h5 className="mt-30">Responses</h5>
                  <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
                     <div class="card">
                        <div class="card-header" id="heading1">
                           <h5 class="mb-0">
                              <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                                 <b>200</b> A response json object {TabCheck1 ?
                                    <FaAngleUp />
                                    :
                                    <FaAngleDown />
                                 }
                              </div>
                           </h5>
                        </div>
                        {
                           TabCheck1 &&
                           <div>
                              <div class="card-body">
                                 <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                                 <hr class="hr-col">
                                 </hr>
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="uniqueLoginKey"><span class="sc-iemWCZ fhDkLh"></span><span>uniqueLoginKey</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>JWT Token.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchantId"><span class="sc-iemWCZ fhDkLh"></span><span>merchantId</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Logged In User’s Merchant Id.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fcmKey"><span class="sc-iemWCZ fhDkLh"></span><span>fcmKey</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Used for Push Notifications.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agId"><span class="sc-iemWCZ fhDkLh"></span><span>agId</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Aggregator Id.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="userId"><span class="sc-iemWCZ fhDkLh"></span><span>userId</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Aggregator Id.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchantKey"><span class="sc-iemWCZ fhDkLh"></span><span>merchantKey</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Key for encrypting data.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="qrCodeImageUrl"><span class="sc-iemWCZ fhDkLh"></span><span>qrCodeImageUrl</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Merchant QR Code Image URL.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sessionKey"><span class="sc-iemWCZ fhDkLh"></span><span>sessionKey</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>AES Encrypted session key to be passed in every request header.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        }
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>400 Bad request</span> </h5>
                        </div>
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
                        </div>
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>404 Not found</span> </h5>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-md-4 extreme-rt-div">
                  <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
                     <div class="card">
                        <div class="card-header" id="heading1">
                           <h5 class="mb-0">
                              <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                                 <button> POST </button> /api/signUpLogin/agId/ paygate {TabCheck1 ?
                                    <FaAngleUp />
                                    :
                                    <FaAngleDown />
                                 }
                              </div>
                           </h5>
                        </div>
                        {
                           TabCheck1 &&
                           <div>
                              <br />
                              <div class="card-body">
                                 <p class="mb-0">Production server (uses live data)</p>
                                 <div class="api-div-bor">
                                    <span>https://www.avantgardepayments.com</span><span
                                       class="col-org">/agadmin/api/signUpLogin/agId/paygate</span>
                                 </div>
                                 <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                                 <div class="api-div-bor">
                                    <span>https://pguat.safexpay.com</span><span
                                       class="col-org">/agadmin/api/signUpLogin/agId/paygate</span>
                                 </div>
                              </div>
                           </div>
                        }
                     </div>
                  </div>
                  <RequestJSON />
                  <ResponseJSON />
               </div>
            </div>
            <hr class="hr-seperator"></hr>
            <SettlementMISAPIDropDown/>
            <hr class="hr-seperator"></hr>
            <div class="row">
               <div class="col-md-8 mt-60">
                  <h2 id="get-transaction-details-sec">Get Transaction Detail API</h2>
                  <p>Transaction Details Summary.</p>
                  <h6><u>AUTHORIZATIONS:</u></h6>
                  <h6 className="mt-10">HEADER PARAMETERS</h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Content-Type">
                              <span class="sc-iemWCZ fhDkLh"></span><span>Content-Type</span>
                              <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>application/json</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="userId">
                              <span class="sc-iemWCZ fhDkLh"></span><span>userId</span>
                              <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This contains encrypted userId with AES encryption</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sessionKey">
                              <span class="sc-iemWCZ fhDkLh"></span><span>sessionKey</span>
                              <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This contains will get in response after login.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <h6>REQUEST BODY SCHEMA:  application-json</h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fromDate"><span class="sc-iemWCZ fhDkLh"></span><span>fromDate</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Transactions beginning from date yyyy-mm-dd.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="toDate"><span class="sc-iemWCZ fhDkLh"></span><span>toDate</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Transactions till date yyyy-mm-dd</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <h5 className="mt-30">Responses</h5>
                  <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
                     <div class="card">
                        <div class="card-header" id="heading1">
                           <h5 class="mb-0">
                              <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                                 <b>200</b> A refund reponse json object {TabCheck1 ?
                                    <FaAngleUp />
                                    :
                                    <FaAngleDown />
                                 }
                              </div>
                           </h5>
                        </div>
                        {
                           TabCheck1 &&
                           <div>
                              <div class="card-body">
                                 <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                                 <hr class="hr-col">
                                 </hr>
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="TOTAL_AMOUNT"><span class="sc-iemWCZ fhDkLh"></span><span>TOTAL_AMOUNT</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="TRANSFERRED_AMOUNT"><span class="sc-iemWCZ fhDkLh"></span><span>TRANSFERRED_AMOUNT</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="TRANSACTION_FEE"><span class="sc-iemWCZ fhDkLh"></span><span>TRANSACTION_FEE</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="GST"><span class="sc-iemWCZ fhDkLh"></span><span>GST</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="PENDING_PAYOUT"><span class="sc-iemWCZ fhDkLh"></span><span>PENDING_PAYOUT</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        }
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>400 Bad request</span> </h5>
                        </div>
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
                        </div>
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>404 Not found</span> </h5>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-md-4 extreme-rt-div mt-60">
                  <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
                     <div class="card">
                        <div class="card-header" id="heading1">
                           <h5 class="mb-0">
                              <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab2}>
                                 <button> POST </button> /sdk/getTxnDetail/userId/ Pooja492{TabCheck2 ?
                                    <FaAngleUp />
                                    :
                                    <FaAngleDown />
                                 }
                              </div>
                           </h5>
                        </div>
                        {
                           TabCheck2 &&
                           <div>
                              <br />
                              <div class="card-body">
                                 <p class="mb-0">Production server (uses live data)</p>
                                 <div class="api-div-bor">
                                    <span>https://www.avantgardepayments.com</span><span
                                       class="col-org">/agmerchant/sdk/getTxnDetail/userId/Pooja492</span>
                                 </div>
                                 <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                                 <div class="api-div-bor">
                                    <span>https://pguat.safexpay.com</span><span
                                       class="col-org">/agmerchant/sdk/getTxnDetail/userId/Pooja492</span>
                                 </div>
                              </div>
                           </div>
                        }
                     </div>
                  </div>
                  <RequestJSONflowtwo />
                  <ResponseJSONflowtwo />
               </div>
            </div>
         </div>
      </div>
   )
}
export default TransactionMIS